module.exports = __webpack_public_path__ + "static/media/accollo2.599bb363.png";